export enum CodeTypeAct {
  attoCartaceo = 'C',
  attoDigitale = 'D',
  nessunAtto = 'N',
}
